export default __webpack_public_path__ + "static/media/004-hat.985a56e8.svg";